import React, { Component } from "react";

import { MDBModalBody, MDBModalHeader, MDBRow, MDBCol } from "mdbreact";

import PendingGatewayVLANEnableTable from "../../../components/NetworkMgmt/Support/Datatables/PendingGatewayVLANEnableTableMUI";
class EquipmentErrorLog extends Component {
    state = {
        pendingGatewayVLANEnable: this.props.pendingGatewayVLANEnable,
    };

    render() {
        return (
         <>
            {/* // <div className="logList"> */}
                <MDBModalHeader
                    toggle={this.props.togglelistPendingGatewayVLANEnable}
                >
                    <h4>Pending Gateway VLAN Enable</h4>
                </MDBModalHeader>
                <MDBModalBody>
                    <MDBRow>
                        <MDBCol col="12">
                           
                                <PendingGatewayVLANEnableTable
                                    pendingGatewayVLANEnable={
                                        this.props.pendingGatewayVLANEnable
                                    }
                                />
                        </MDBCol>
                    </MDBRow>
                </MDBModalBody>
            {/* // </div> */}
            </>
        );
    }
}

export default EquipmentErrorLog;
